export const GET_ALL_REPORTS = "GET_ALL_REPORTS";
export const START_LOADING_REPORTS = "START_LOADING_REPORTS";
export const ERROR_LOADING_REPORTS = "ERROR_LOADING_REPORTS"
export const STOP_LOADING_REPORTS = "STOP_LOADING_REPORTS";
export const RESET_DATA = "RESET_DATA";
